export const devices = {
    MOBILE: "mobile",
    TABLET: "tablet",
    DESKTOP: "desktop",
} as const;

const TYPICAL_DPI = 160;
const MOBILE_MAX_DIAGONAL = 6;

export function determineDevice(
    { userAgent, maxTouchPoints }: { userAgent: string, maxTouchPoints?: number },
    { width, height }: { width: number, height: number },
) {
    if (userAgent.match(/(iphone|ipod)/i)) {
        return devices.MOBILE;
    }
    if (userAgent.match(/ipad/i)) {
        return devices.TABLET;
    }
    if (userAgent.match(/Mac/) && maxTouchPoints && maxTouchPoints > 2) {
        return devices.TABLET;
    }
    if (userAgent.match(/(android|mobile)/i)) {
        const approximateDiagonal = Math.sqrt(width ** 2 + height ** 2) / TYPICAL_DPI;
        if (approximateDiagonal < MOBILE_MAX_DIAGONAL) {
            return devices.MOBILE;
        } else {
            return devices.TABLET;
        }
    }
    if (window.innerWidth < 768) {
        return devices.MOBILE;
    }
    return devices.DESKTOP;
}
